import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CrmActionButton, CrmActionButtonsComponent } from 'common-module/buttons';

export enum FooterActionId {
  confirm = 'modal_footer_confirm',
  cancel = 'modal_footer_cancel'
}

@Component({
  selector: 'app-modal-footer',
  template: `
    <div class="modal-footer">
      <crm-action-buttons
        [actions]="actions"
        (actionClicked)="actionClicked.emit($event)"
      ></crm-action-buttons>
    </div>
  `,
  imports: [CrmActionButtonsComponent],
  standalone: true
})
export class ModalFooterComponent {
  @Input() public actions: CrmActionButton[] = [
    {
      title: 'modal.footer.confirm',
      type: 'primary',
      id: FooterActionId.confirm
    },
    {
      title: 'modal.footer.cancel',
      id: FooterActionId.cancel,
      className: 'ant-btn-secondary'
    }
  ];
  @Output() public actionClicked = new EventEmitter<CrmActionButton>();
}
